import useStore from '../zustand/useStore';
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ButtonGroup,
  Button,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFilter,
  faList,
  faBorderAll,
} from '@fortawesome/free-solid-svg-icons';

const FilterBar = () => {
  const {
    countries,
    view,
    filters,
    slots,
    settings: {
      params: { displayviewswitch },
    },
    changeView,
    setFilter,
  } = useStore((state) => ({
    countries: state.countries,
    view: state.view,
    filters: state.filters,
    slots: state.slots,
    settings: state.settings,
    changeView: state.changeView,
    setFilter: state.setFilter,
  }));
  return (
    <Grid container style={{ width: '100%', margin: '3rem auto 0' }}>
      <Grid item xs={12} style={{ margin: '0 0 1rem' }}>
        {/* <strong>{rows.length}</strong> search results */}
      </Grid>
      <Grid
        item
        xs={8}
        style={{ paddingBottom: '1rem', borderBottom: '1px solid lightgrey' }}
      >
        <FontAwesomeIcon icon={faFilter} style={{ marginRight: '1rem' }} />{' '}
        Filters
      </Grid>
      <Grid
        item
        xs={4}
        style={{
          paddingBottom: '1rem',
          borderBottom: '1px solid lightgrey',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        {displayviewswitch === true && (
          <ButtonGroup variant="outlined" color="primary" disableRipple>
            <Button
              variant={view === 'card' ? 'contained' : 'outlined'}
              onClick={() => changeView('card')}
            >
              <FontAwesomeIcon
                icon={faBorderAll}
                style={{ marginRight: '.5rem', fontSize: '1.1rem' }}
              />
              Card view
            </Button>
            <Button
              variant={view === 'list' ? 'contained' : 'outlined'}
              onClick={() => changeView('list')}
            >
              <FontAwesomeIcon
                icon={faList}
                style={{ marginRight: '.5rem', fontSize: '1.1rem' }}
              />
              List view
            </Button>
          </ButtonGroup>
        )}
      </Grid>
      <Grid
        item
        xs={12}
        style={{ paddingBottom: '1rem', borderBottom: '1px solid lightgrey' }}
      >
        <Grid
          container
          spacing={3}
          style={{ marginTop: '-0.5rem', padding: '1rem 0' }}
        >
          {/* Date filter */}
          <Grid item xs={4}>
            <FormControl variant="filled" fullWidth>
              <InputLabel id="date-filter-label">Date</InputLabel>
              <Select
                variant="filled"
                id="date-filter"
                labelId="date-filter-label"
                value={filters.date}
                disabled={filters.date.length > 0}
                onChange={(e) => {
                  setFilter('date', e.target.value);
                }}
              >
                {slots &&
                  slots.map((date, index) => {
                    return (
                      <MenuItem key={index} value={date}>
                        {date}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </Grid>

          {/* Country filter */}
          <Grid item xs={4}>
            <FormControl variant="filled" fullWidth>
              <InputLabel id="country-filter-label">Country</InputLabel>
              <Select
                variant="filled"
                id="country-filter"
                labelId="country-filter-label"
                value={filters.country}
                disabled={filters.country.length > 0}
                onChange={(e) => {
                  setFilter('country', e.target.value);
                }}
                MenuProps={{
                  PaperProps: { sx: { top: '25vh', maxHeight: '50vh' } },
                }}
              >
                {countries &&
                  countries.map((country) => {
                    return (
                      <MenuItem key={country} value={country}>
                        {country}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </Grid>
          {/* Type filter */}
          <Grid item xs={4}>
            <FormControl variant="filled" fullWidth>
              <InputLabel id="type-filter-label">Type</InputLabel>
              <Select
                variant="filled"
                id="type-filter"
                labelId="type-filter-label"
                disabled={filters.type.length > 0}
                value={filters.type}
                onChange={(e) => {
                  setFilter('type', e.target.value);
                }}
              >
                <MenuItem value="Policy statement">Policy statement</MenuItem>
                <MenuItem value="Speech">Speech</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FilterBar;
